import { Card } from '@ps/isp-web-component-library';
import type { TranslationTag } from '@ps/web-core-intl';
import { Link, Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { getHistoricalBetsAlias } from '@swf/sports/utils/getHistoricalBetsAlias';
import { getMyBetsAlias } from '@swf/sports/utils/getMyBetsAlias';

import FormattedDateTime from '../FormattedDateTime/FormattedDateTime';

import {
  TXTWCL_For_bets_placed_on_or_after_N0_ELL,
  TXTWCL_For_bets_placed_on_or_before_N_ELL,
  TXTWCL_Historical_Bets,
  TXTWCL_My_Bets
} from './BetsLink.messages.json';
import styles from './BetsLink.scss';

interface Props {
  type: Type;
  status: string;
  isEmbedded?: boolean;
  isSelfExcluded: boolean;
}

type Type = 'my-bets' | 'historical-bets';

interface Config {
  textTranslation: TranslationTag;
  linkTranslation: TranslationTag;
}

const linksConfig: Record<Type, Config> = {
  'my-bets': {
    textTranslation: TXTWCL_For_bets_placed_on_or_after_N0_ELL,
    linkTranslation: TXTWCL_My_Bets
  },
  'historical-bets': {
    textTranslation: TXTWCL_For_bets_placed_on_or_before_N_ELL,
    linkTranslation: TXTWCL_Historical_Bets
  }
};

const BetsLink: React.FC<Props> = ({ type, status, isEmbedded, isSelfExcluded }) => {
  const launchDate = useSelector(select.cms.getWebsiteLaunchDate);

  if (!launchDate) {
    return null;
  }

  const { textTranslation, linkTranslation } = linksConfig[type];

  const alias =
    type === 'my-bets'
      ? getMyBetsAlias(isSelfExcluded, isEmbedded)
      : getHistoricalBetsAlias(isSelfExcluded, isEmbedded);

  return (
    <Card isPadded className={styles.wrapper}>
      <Translation
        {...textTranslation}
        values={{
          0: <FormattedDateTime date={launchDate} format="long" weekday="long" hideTime />,
          1: (
            <Link className={styles.link} alias={alias} values={{ status }}>
              <Translation {...linkTranslation} />
            </Link>
          )
        }}
      />
    </Card>
  );
};

export { BetsLink };
